<template>
  <div class="grid-view">
    <div
      v-show="showMainList"
      class="main-content"
    >
      <search-item
        config-module="231402"
        :reset="true"
        no="1"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
        @advSearchItemResetCallBack="toAdvancedQuery"
      >
        <template slot="operations">
          <div>
            <el-button type="primary" no="2" @click="toCancelSpecialApproval(null)">{{ $t('CargoMsg.Cargo_CancelSpecialApproval') }}</el-button>
          </div>
        </template>
        <cargo-advance-select
          slot="customCompany"
          slot-scope="{ item, getValueFromChild }"
          :select-type="TYPE_NAMES.basic_data_Company"
          :clear-not-match="true"
          filterable
          :callback-params="{ refCode: item.itemName, fieldType: item.fieldType }"
          :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
          :multiple="true"
          :tag-value="item.tagValue !== '' ? item.tagValue : item.subType.tagValue"
          options-width="300px"
          :headers="item.headers || []"
          :fields="item.fields || []"
          :tag-name="item.tagName"
          placeholder=" "
          :static-options="overCreditAccounts"
          @parentCallBack="data=>getValueFromChild(data)"
        />
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="23140200"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          no="3"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="23140200"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          :page-sizes="[10, 20, 30, 50, 100, 200, 500]"
          no="4"
          @pagination="toQuery"
        />
      </div>
    </div>
    <!--信控情况-->
    <credit-info-dialog
      ref="creditInfo"
      :visible="creditInfoVisible"
      :dialog-row-data="creditInfoList"
      no="5"
      @onClose="creditInfoClose"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import CreditInfoDialog from '@/views/cargo/v0/Sales/components/CreditBusinessManage/creditInfoDialog'
import {
  querySpecialApprovalList,
  queryCreditInfo,
  cancelSpecialApproval,
  querySpecialOverCreditAccountIds
} from '@/api/sales/creditBusinessManage'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import RouterAndPrintRenderer from '@/components/Cargo/Common/routerAndPrintRenderer'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { getFilterCacheList } from '@/utils/basicDataCache'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'TabSpecialApproval',
  components: {
    searchItem, CreditInfoDialog, cargoAdvanceSelect
  },
  data() {
    return {
      URL,
      TYPE_NAMES,
      creditInfoVisible: false,
      rowData: [],
      creditInfoList: [],
      isAdvancedQuery: false, // 是否为高级查询
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      filterJson: {},
      showDetail: false,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: {
          RouterAndPrintRenderer
        },
        onCellDoubleClicked: event => {
          this.toLook(event.data)
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_SpecialApprovalTime'), field: 'creditControlTime', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_SpecialApprovalUser'), field: 'creditControlUser', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          } },
        {
          headerName: this.$t('Payment.businessNumber'), field: 'jobJobNo', width: 200
        }, { headerName: this.$t('Payment.warehouseNo'), field: 'jobWarehouseNo', width: 200 },
        { headerName: this.$t('Payment.bookingNo'), field: 'jobBookingNo', width: 200 },
        { headerName: this.$t('Payment.SONO'), field: 'jobSoNo', width: 200 },
        { headerName: this.$t('Payment.itemNo'), field: 'jobPoNo', width: 200 },
        {
          headerName: this.$t('SeaExport.DateOfArrival'), field: 'jobEta', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.DateOfDeparture'), field: 'jobEtd', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.mbl'), field: 'jobMbl', width: 200 },
        { headerName: this.$t('Payment.separateNumber'), field: 'jobHbl', width: 200 },
        {
          headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'jobOverseaOp', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          hide: true
        },
        {
          headerName: this.$t('Payment.consignationCompany'), field: 'jobCustomerId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.NominatedAgent'), field: 'jobDesignationAgent', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.solicitationType'), field: 'jobCargoSource', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('Payment.carrier'), field: 'jobCarrierId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.businessType'), field: 'jobLob', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.businessDate'), field: 'jobBusinessDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.customJobType'), field: 'jobCustomJobType', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.value, 'name')
          }
        },
        { headerName: this.$t('Payment.vesselAndVoyage'), field: 'jobVessel', width: 200 },
        {
          headerName: this.$t('Payment.portOfLoading'), field: 'jobLoadingPortCode', width: 200,
          cellRenderer: (params) => {
            if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('Payment.portOfDestination'), field: 'jobDestinationPortCode', width: 200,
          cellRenderer: (params) => {
            if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('SeaExport.departureStation'), field: 'jobDepartureStation', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.destinationStation'), field: 'jobDestinationStation', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.transitStation'), field: 'jobTransitStation', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('Payment.destinationAgent'), field: 'jobDestinationAgent', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.operation'), field: 'jobOp', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.sales'), field: 'jobSales', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.customerService'), field: 'jobCsr', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.Documents'), field: 'jobDc', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Payment.businessReferenceNumber'), field: 'jobCustomerRefNo', width: 200 },
        { headerName: this.$t('Payment.relatedJob'), field: 'jobRelatedJob', width: 200 },
        { headerName: this.$t('Payment.trustFromJob'), field: 'jobTrustFromJob', width: 200 },
        {
          headerName: this.$t('Payment.planner'), field: 'jobPlanner', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.accrued'), field: 'jobProvisioned', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('Payment.businessStatus'), field: 'jobJobState', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.jobStateLabelFunc(params.value)
          },
          hide: true
        },
        { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'jobUserDefinedField1', width: 200 },
        { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'jobUserDefinedField2', width: 200 },
        { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'jobUserDefinedField3', width: 200 },
        { headerName: this.$t('SeaExport.UserDefinedField4'), field: 'jobUserDefinedField4', width: 200, hide: true },
        {
          headerName: this.$t('Invoice.invoice_salesDepartment'), field: 'jobSalesDepartment', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', params.value, 'chineseName')
          },
          hide: true
        },
        { headerName: this.$t('CargoMsg.Cargo_SpecialApprovalValidUntil'), field: 'specialApprovalDate', width: 150, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Sales.OverControllAccountReceivable'),
          field: 'overCreditAccountIds',
          width: 200,
          valueFormatter: params => {
            if (params.value) {
              const vals = params.value.split(',')
              const txts = []
              for (const val of vals) {
                txts.push(ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(val), 'chineseName'))
              }
              return (vals.length > 1 ? `【${vals.length}${this.$t('Sales.Family')}】` : '') + txts.join(',')
            }
            return ''
          },
          hide: true
        }
      ],
      overCreditAccounts: []
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.loadOverCreditAccounts()
      this.toQuery()
    }
  },
  beforeMount() {
    this.loadOverCreditAccounts()
    this.toQuery()
  },
  methods: {
    loadOverCreditAccounts() {
      const loading = getLoading4Cxt(this)
      querySpecialOverCreditAccountIds({ branchId: this.$store.getters.currentOfficeId }).then(res => {
        loading.close()
        this.overCreditAccounts = getFilterCacheList(TYPE_NAMES.basic_data_Company, p => res.data.includes(p.cmpIdx))
      }).catch(() => {
        loading.close()
      })
    },
    fetchOrderRequirement() {
      this.fullscreenLoading = getLoading()
      querySpecialApprovalList(this.filter)
        .then((res) => {
          this.filter.total = Number(res.data.total)
          this.rowData = res.data.list
          this.fullscreenLoading.close()
        })
        .catch(() => {
          this.fullscreenLoading.close()
        })
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword
        this.filter.pageNum = 1
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      querySpecialApprovalList(this.filter).then((res) => this.handleQueryData(res)).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.fullscreenLoading.close()
    },
    toAdvancedQuery(data) {
      console.log('----toAdvancedQuery----')
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = this.handleConditionsBeforeQuery(data)
        this.filter.pageNum = 1
      }
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      querySpecialApprovalList(this.filterJson).then((res) =>
        this.handleQueryData(res)
      ).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    // 在查询之前，对条件进行预处理
    handleConditionsBeforeQuery(data) {
      if (AdvancedSearchOption.hasField('charge.ACCOUNT_ID', data)) {
        const condition = new AdvancedSearchOption(null, 'charge.ACCOUNT_RECEIVABLE', true)
        data.push(condition.formatObj2Json())
      }
      return data
    },
    // 特批
    toCancelSpecialApproval() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.error('请选择特批的业务')
        return
      }
      const ids = selectedRows.map((item) => item.jobUuid)
      cancelSpecialApproval({ jobUuids: ids.join(',') }).then((res) => {
        this.$message.success(this.$t('Sales.CancelledSpecialApprovalSuccessful'))
        this.toAdvancedQuery()
      })
    },
    toLook(data) {
      const param = {
        companyId: data.jobCustomerId,
        designationAgent: data.jobDesignationAgent,
        jobUuid: data.jobUuid
      }
      queryCreditInfo(param).then((res) => {
        this.creditInfoList = res.data
        this.creditInfoVisible = true
      })
    },
    creditInfoClose() {
      this.creditInfoVisible = false
    }
  }
}
</script>
